//import liraries
import React, { Component, useState, useEffect } from "react";
import { View, Text, FlatList, ScrollView, TouchableOpacity, Image, TextInput,} from "react-native";
import { get, isEmpty } from "lodash";
import { getAllVehiclesList, filterVehicle } from "./../../api/apiManager";
import Loader from "./../../common/Loader";
import useStyles from "./TagDetails_Styles";
import RootNavigation from "../../utilities/RootNavigation";

const TagDetails = (props) => {
  const styles = useStyles();
  const [vehicleList, setVehicleList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getVehicleList();
  }, []);

  useEffect(() => {
    if (searchText && searchText.length > 2) {
      searchFilter();
    } else if ((searchText && searchText.length < 2) || searchText == "") {
      getVehicleList();
    }
  }, [searchText]);

  const getVehicleList = () => {
    setLoading(true);
    getAllVehiclesList()
      .then((res) => {
        if (res && !isEmpty(res)) {
          setVehicleList(res);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in tag details ----------->");
      });
  };

  // new api integration - filter
  const searchFilter = () => {
    setLoading(true);
    let req = {
      vrn_contains: searchText,
      assignedVrnList: null,
    };
    filterVehicle(req)
      .then((res) => {
        setVehicleList(res || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("<------------ error in tag details ----------->");
      });
  };

  return (
    <View style={styles.mainContainer}>
      {
        searchText =="" && vehicleList.length === 0
        ? null
        : <View style={styles.topViewStyle}>
        
        <View style={styles.secondRowStyle}>
          <Text style={styles.searchTextStyle}>{"Search"}</Text>
          <TextInput
            style={styles.searchTextInputStyle}
            placeholder={"Vehicle Reg No."}
            value={searchText}
            onChangeText={(t) => {
              setSearchText(t);
            }}
          />
          <TouchableOpacity style={styles.searchIconContainerStyle}>
            <Image
              source={require("../../assets/images/search_icon.png")}
              style={styles.searchIconStyle}
            />
          </TouchableOpacity>
        </View>
      </View>
      }
      
      {searchText =="" &&vehicleList.length === 0 ? (
        <View
          style={[
            styles.cardContainer,
            { alignItems: "center", justifyContent: "center" },
          ]}
        >
          <Text style={{ fontFamily: "Inter", fontSize: 26, fontWeight: "normal", fontStyle: "normal", lineHeight: 36, letterSpacing: 0, textAlign: "left", color: "#66625f", paddingTop: 15,paddingLeft:10}}>
            {"You have not added any tag."}
            </Text>
        
        </View>
      ) : (
        <View style={styles.cardContainer}>
          <View style={styles.container}>
            <ScrollView showsHorizontalScrollIndicator={true} horizontal={true}>
              <View style={{ width: "100%", borderRadius: 20 }}>
                <View style={styles.headerViewStyle}>
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 120, minWidth: 120 },
                    ]}
                  >
                    {"Vehicle Reg. No"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 80, minWidth: 80 },
                    ]}
                  >
                    {"Chassis No"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 110, minWidth: 110 },
                    ]}
                  >
                    {"Mobile No"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 110, minWidth: 110 },
                    ]}
                  >
                    {"Tag Minimum Threshold"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>
                    {"Classi-fication"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 110, minWidth: 110 },
                    ]}
                  >
                    {"Reg.Date"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text
                    style={[
                      styles.headerTextStyle,
                      { width: 140, minWidth: 140 },
                    ]}
                  >
                    {"Tag ID"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>{"Vehicle name"}</Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>
                    {"Available Balance"}
                  </Text>
                  <View style={styles.verticalLineStyle} />
                  <Text style={styles.headerTextStyle}>{"Tag Status"}</Text>
                </View>

                <FlatList
                  style={{}}
                  showsVerticalScrollIndicator
                  data={vehicleList}
                  showsHorizontalScrollIndicator
                  keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                  renderItem={({ item, index }) => {
                    return (
                      <View>
                        <View
                          style={[
                            styles.dataViewStyle,
                            {
                              backgroundColor:
                                index % 2 !== 0 ? "#ffffff" : "#E5E5E5",
                            },
                          ]}
                        >
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 120, minWidth: 120 },
                            ]}
                          >
                            {get(item, "vrn", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 80, minWidth: 80 },
                            ]}
                          >
                            {get(item, "chassisNo", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 110, minWidth: 110 },
                            ]}
                          >
                            {get(item, "mobileNo", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 110, minWidth: 110 },
                            ]}
                          >
                            {get(item, "minimumThreshold", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={styles.rowStyle}>
                            {item.classification}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 110, minWidth: 110 },
                            ]}
                          >
                            {get(item, "regDate", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              { width: 140, minWidth: 140 },
                            ]}
                          >
                            {get(item, "fastagId", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={styles.rowStyle}>
                            {get(item, "vehicleModel", "")}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text style={styles.rowStyle}>
                            {get(item, "fastagBalance", "").toFixed(2)}
                          </Text>
                          <View style={styles.verticalLineStyle} />
                          <Text
                            style={[
                              styles.rowStyle,
                              {
                                color:
                                  get(item, "status", "") == "Activated"
                                    ? "#2bd202"
                                    : "#c32b2c",
                              },
                            ]}
                          >
                            {get(item, "status", "")}
                          </Text>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </ScrollView>
          </View>
        </View>
      )}

      {loading && <Loader />}
    </View>
  );
};

//make this component available to the app
export default TagDetails;
